import { render, staticRenderFns } from "./ComplaintQualityForm.vue?vue&type=template&id=6c5142da&scoped=true"
import script from "./ComplaintQualityForm.vue?vue&type=script&lang=js"
export * from "./ComplaintQualityForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintQualityForm.vue?vue&type=style&index=0&id=6c5142da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5142da",
  null
  
)

export default component.exports